import styled from "styled-components";
import { BsArrowDown, BsArrowLeft, BsChevronDown } from "react-icons/bs";
import theme from "../../modules/themes";
import description from "../../assets/ademars/1_landing_page/AP_Marvel_REVEAL_Hero.png";
import { HiOutlineChevronDown } from "react-icons/hi";
import { FaGalacticRepublic, FaLevelDownAlt } from "react-icons/fa";
import { GrDown } from "react-icons/gr";

export const Wrapper = styled.section`
  min-height: ${window.innerHeight}px;
  background-color: black;
  position:relative;
  opacity: 1
`;

export const BackgroundImage = styled.section`
  height: ${window.innerHeight}px;
  background-image: url("${description}");
  background-size: cover;
  background-position: center;
  position:relative;
  background-color: black:
`

export const Container = styled.section`
  width: 85%;
  margin: auto;
  // opacity: 0;
  // position:relative
  background-color: black:
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items:flex-end;
  text-align:right
`;


export const SecondaryTitle = styled.h1`
  width: 87%;
  font-family: helvetica-neue-extra-light;
  margin: 0 auto;
  font-size: 45px;
  color: #ffffff;
  text-transform: uppercase;
  padding:0;
  line-height:1.1;
  font-weight: 200;

  @media(max-width:460px){
    font-size: 33px;
  }

  @media(max-width:375px){
    font-size: 28px;
  }

  @media(max-width:330px){
    font-size: 26px;
  }

  @media(min-width:500px){
    font-size: 42px;
  }
  
`;

export const SecondaryTitleTimes = styled.h1`
  width: 87%;
  font-family: times-now-extra-light;
  margin: 0 auto;
  font-size: 46px;
  color: #ffffff;
  text-transform: uppercase;
  padding:0;
  line-height:1.1;
  font-weight: 200;

  @media(max-width:460px){
    font-size: 35px;
  }

  @media(max-width:375px){
    font-size: 30px;
  }

  @media(max-width:330px){
    font-size: 28px;
  }

  @media(min-width:500px){
    font-size: 44px;
  }

`

export const Fall = styled.section`
  min-height: ${window.innerHeight}px;
  width:100%;
  background-color: black;
  position:relative;

  .end-container {
    background-color: black; 
    padding: 5.5rem 0 1.9rem 0;
    @media(max-width:450px){
      padding: 4rem 0 1.6rem 0;
    }
  }

  .first-player-container{
    margin: 1.7rem 0 2.5rem 0;
    background-color: black;
    width:100%;
    height: 22rem;

    @media(max-width: 450px){
      margin: 1.7rem 0 2rem 0;
    }

    @media(max-width: 355px){
      margin: 1.2rem 0 1.1rem 0;
      height: 15rem;
    }
  }

  .player-container{
    margin: 2rem 0 7rem 0;
    background-color: black;
    width:100%;
    height: 22rem;

    @media(max-width: 355px){
      margin: 2rem 0 5rem 0;
    }
  }

  .player-container-second{
    margin: 6rem 0 6rem 0;
    background-color: black;
    width:100%;
    height: 22rem;
  }

  .para-one{
    width: 87%;
    margin: 2.25rem auto 2.9rem auto;
    color: white;
    font-size:16px;
    line-height:1.5;

    .first, .second, .third, .fourth, .five {
      display: block;
    }


    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      .first, .second, .third, .fourth, .five {
        display: block
      }
      font-size:12px;
      margin: 2rem auto 2.9rem auto;
    }

    @media(max-width:355px){
      margin: 0.8rem auto 0 auto;
      .first, .second, .third, .fourth, .five {
        display: inline
      }
    }
  }

  .para-two{
    width: 87%;
    margin: 1.2rem auto 0 auto;
    color: white;
    font-size:20px;
    line-height:1.7;

    .first, .second, .third {
      display: block
    }

    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      margin: 1rem auto 0 auto;
      .first, .second, .third {
        display: block
      }
      font-size:13px;
    }

    @media(max-width:355px){
      margin: 0.8rem auto 0 auto;
      .first, .second, .third {
        display: inline
      }
    }

    @media(min-width:500px){
      font-size:17px;
    }
  }
`

export const LivelySectionHorizontal =styled.div`
  width: 30%;
  border: 0.5px #d87a3e solid;
  margin: 5px 0;

  @media(max-width:430px){
    width: 25%;
    margin: 4px 0;
    height: 1px;
    background-color:#d87a3e;
    border: 0;
  }

  @media(max-width:380px){
    width: 25%;
    margin: 3px 0;
  }
`




export const ScrollIndicatorContainer = styled.section`
  position: absolute;
  width: 100%;
  left: 0;
  right:250;
  bottom: 1.5rem;
  opacity:0;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center
  `
  
  
  export const ScrollIndicatorSection = styled.section`
  width:50%;
  margin:20px auto 0 auto;
  height:50px;
  text-align: center;
  background-color: ${theme.primaryYellow};
  display:flex;
  align-items:center;
  justify-content:center;

  @media(max-width:450px){
    height:40px;
    width:40%;
  }
`;
  
  export const ScrollIndicatorText = styled.div`
  font-size: 14px;
  font-weight:600;
  color: white;

  @media(max-width:430px){
    font-size: 10px;
  }

`;

export const ScrollIndicatorIcon = styled(BsChevronDown)`
  margin-top: 0.3rem;
  color: white;
  
  @media(max-width:430px){
    margin-right:0
  }
`;


export const LoadContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 110;
  pointer-events: none;
`;

export const LoadScreen = styled.div`
  position: relative;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  height: 100%;
  // background-color: #161616;
  background-color: #121213;
  margin-top: ${window.innerHeight}px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;

  @font-face {
    font-name: alternate_gothic_bold;
    src: url(../../assets/fonts/Alternate-Gothic-No-2-BT.ttf);
  }

  font-family: alternate_gothic_bold;

  img{
    width:80%;
  }

`;














export const LoadTitle = styled.div`
  font-size: 9vw;
  color: #d87a3e;
  margin: 0;
  line-height: 0.8;

  @media (min-width: 600px) {
    font-size: 46px;
  }
`;

export const TitlesSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3.6vw 0 0 0;
  height: 15vh;
  opacity: 0;
  position:absolute;
  width:100%;
  top:9%;
  left:50%;
  transform:translate(-50%,-50%);

  img{
    width:80%;
    display:inline;
  }

  @media (max-width: 700px) {
    padding: 6.6vw 0 0 0;
  }
`;


export const CardContainer = styled.div`

  width: 95%;
  margin:auto;
  padding-top 0.5rem;

  .close-icon-container{
    display: flex;
    width:100%;
    justify-content: flex-end
  }

  .close-icon{
    width:1.5rem;
    height: 1.5rem;
  }

  p{
    font-family:'times-now-extra-light';
    font-size:1.3rem;
    padding-bottom:0.5rem
  }
  li{
    font-size:0.7rem;
    list-style:none
  }

`


export const DropDownSection = styled.section`

  width: 100%;
  background-color: black;
  // border: 1px solid white;
  padding-top: 39px;
  padding-bottom: 80px;

  img {
    margin-top: 5rem
  }

  h2{
    text-align: center;
    text-transform: uppercase;
    color: white;
    cursor: pointer;
    transition: 0.1s ease-in;
    font-size: 26px;
    font-weight: 200
  }
  .dropdown-hide {
    height: 0px;
    transition: 1s;
    overflow: hidden;
    opacity: 0
  }
  .dropdown-show {
    width: 100%;
    height: 1000px;
    background-color: black;
    transition: 1s;
    opacity: 1;
    overflow: visible;
    padding: 24px 0 0 0
  }

  .list{
    color: white;
    width: 80%;
    margin: 39px auto;
  }

  .list li {
    list-style: none
  }
  .list li h4{
    text-transform: uppercase;
    font-weight: 200;
    font-size: 17px;
    letter-spacing: 2px
  }
  .list li p{
    margin-top: 9px;
    font-size: 17px;
    line-height: 1.7;
  }


  @media (max-width: 450px) {
    .dropdown-show {
      // height: 1015px;
    }
    h2{
      font-size: 22px;
    }
    .list li p{
      font-size: 15px;
    }
    img {
      margin-top: 4.5rem
    }
    padding-bottom: 75px
  }

  @media (max-width: 350px) {
    .dropdown-show {
      height: 1060px;
    }
  }


`